<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div id="devlabel" *ngIf="label">{{ label }}</div>
<div id="splashcontainer" [hidden]="ingelogd">
    <div id="splash" *ngIf="msg">{{ msg }}</div>
    @if (wachtwoordzichtbaar) {
        <wachtwoord [weergave]="wachtwoordweergave" [uid]="wachtwoorduid" [code]="wachtwoordcode"
                    (klaar)="wachtwoordKlaar($event)"></wachtwoord>
    } @else {
        <div id="logindlg" [class.inlogin]="inlogin">
            <img id="loginlogo" alt="ATR" class="d-block mx-auto" src="../assets/img/atr_logo.png">
            <form #inlogForm="ngForm" (ngSubmit)="doeLogin()">
                <div class="form-group">
                    <label for="email">E-mailadres</label>
                    <input type="email" class="form-control" email spellcheck="false"
                           name="email" id="email" autocomplete="username" #emailveld
                           required
                           [(ngModel)]="login.email">
                </div>
                <div class="form-group">
                    <label for="wachtwoord">Wachtwoord</label>
                    <input type="password" class="form-control" autocomplete="current-password"
                           name="wachtwoord" id="wachtwoord" #wachtwoordveld
                           required
                           [(ngModel)]="login.wachtwoord">
                </div>
                <div class="text-center">
                    <button class="btn btn-primary" type="submit" [disabled]="!inlogForm.form.valid">Inloggen</button>
                </div>
            </form>
            <div class="text-center mt-2">
                <a class="wachtwoordvergeten" (click)="wachtwoordVergeten()">Wachtwoord vergeten?</a>
            </div>
            <div class="appname"><span class="atr">ATR</span><span class="plan">plan</span></div>
        </div>
    }
</div>
<ng-container *ngIf="ingelogd">
    <nav class="navbar navbar-expand-md navbar-light">
        <div class="navbar-brand">
            <div class="appname"><span class="atr">ATR</span><span class="plan">plan</span></div>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navcollapse">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navcollapse">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="ddplanbord" data-testid="planningmenu"
                       role="button"
                       *ngIf="api.can('planitem','*')"
                       data-toggle="dropdown">Planning</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"
                           data-testid="openplanbord" (click)="open('Planbordscherm')"><span class="fas fa-th"></span>
                            Planbord</a>
                        <a *ngIf="api.can('planitem','full')" class="dropdown-item" data-testid="openbamimport"
                           (click)="open('Bamimportscherm')"><span class="fas fa-industry"></span> Import BAM</a>
                        <a *ngIf="api.can('planitem','read')" class="dropdown-item"
                           (click)="open('Werkbonnenlijstscherm')"><span
                                class="fas fa-file-signature"></span>
                            Werkbonnen</a>
                        <a *ngIf="api.can('planitem','read')" class="dropdown-item"
                           (click)="open('Totaalexportscherm')"><span
                                class="fas fa-file-export"></span>
                            Totaalexport</a>
                    </div>
                </li>
                <li *ngIf="api.can('project','read')" class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" id="ddproject" role="button">Project</a>
                    <div class="dropdown-menu">
                        <a (click)="open('Projectlijstscherm')" *ngIf="api.can('project','read')" class="dropdown-item"><span
                                class="fas fa-hard-hat"></span> Projecten</a>
                    </div>
                </li>
                <li class="nav-item dropdown"
                    *ngIf="api.can('planitem','read') && api.can(['personeelvast','leverancier'],'read')">
                    <!-- harde check op planitem read, zodat groepen met gedeeltelijke toestemmingen niet erin komen -->
                    <a class="nav-link dropdown-toggle" href="#" id="ddgegevens" role="button" data-toggle="dropdown">Personeel</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" *ngIf="api.can('personeelvast','read')"
                           (click)="open('Vastpersoneelscherm')"><span
                                class="fas fa-people-carry"></span> Personeel</a>
                        <a class="dropdown-item" *ngIf="api.can('leverancier','read')"
                           (click)="open('Leverancierlijstscherm')"><span
                                class="fas fa-truck"></span> Leveranciers</a>
                        @if (api.can('personeelvast', 'read')) {
                            <a class="dropdown-item" (click)="open('Toolboxlijst')"><span
                                    class="fas fa-toolbox"></span> Toolbox</a>
                        }
                    </div>
                </li>
                <li class="nav-item dropdown" data-testid="adminmenu"
                    *ngIf="api.userdata?.app_admin || api.can('project','full') || api.can('exact','sync') || api.userdata?.exact_admin">
                    <a class="nav-link dropdown-toggle" href="#" id="ddadmin" role="button"
                       data-toggle="dropdown">Admin</a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" *ngIf="api.userdata?.app_admin"
                           (click)="open('Gebruikersscherm')"><span class="fas fa-users"></span> Gebruikers</a>
                        <a class="dropdown-item" *ngIf="api.can('exact', 'sync') || api.can('project','full')"
                           (click)="api.syncExact()"><span class="fas fa-sync"></span> Synchroniseer exact
                            ({{ api.werkmaatschappij.afkorting }})</a>
                        <a class="dropdown-item" *ngIf="api.userdata?.exact_admin"
                           (click)="api.syncExact(true)"><span class="fas fa-sync"></span> Synchroniseer exact
                            (alles)</a>
                        <a class="dropdown-item" (click)="exactKoppelen()" *ngIf="api.userdata?.exact_admin"><span
                                class="fas fa-laptop-code"></span> Herkoppel exact</a>
                        <ng-container *ngIf="api.userdata?.app_admin || api.userdata?.exact_admin">
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" data-testid="openexactlog" (click)="open('Exactlog')"><span
                                    class="fas fa-cash-register"></span>
                                Exactlog</a>
                        </ng-container>
                    </div>
                </li>
            </ul>
            <ul class="navbar-nav">
                @if (api.userdata?.werkmaatschappijen?.length > 1) {
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" role="button" data-toggle="dropdown"
                           [title]="'Je werkt in: ' + api.werkmaatschappij.naam ">Werkmaatschappij: {{ api.werkmaatschappij.naam }}</a>
                        <div class="dropdown-menu">
                            @for (wm of api.userdata.werkmaatschappijen; track wm.id) {
                                <a class="dropdown-item" [title]="wm.naam"
                                   (click)="switchWerkmaatschappij(wm.id)">{{ wm.afkorting }}</a>
                            }
                        </div>
                    </li>
                } @else {
                    <div class="navbar-text">Werkmaatschappij: {{ api.werkmaatschappij.naam }}</div>
                }
                <li class="nav-item"><a class="nav-link" data-testid="sluitalllesknop" (click)="closeAll()">Sluit
                    alles</a></li>
                <li class="nav-item">
                    <a class="nav-link" (click)="logout()" data-testid="uitloggen"
                       [attr.title]="'Uitloggen ' + api.userdata.gebruikersnaam"><i
                            class="fas fa-sign-out-alt"></i></a>
                </li>
            </ul>
        </div>
    </nav>
    <windowmanager #mgr></windowmanager>
    <div id="openwindows">
        <button class="btn" *ngFor="let wnd of mgr.windows" [class.actief]="wnd.actief" [title]="wnd.title"
                (click)="wnd.naarVoren()"><span class="close" (click)="wnd.close()"
                                                *ngIf="wnd.closeButton">&times;</span><span
                [class]="'wndicon ' + wnd.icon"></span> {{ wnd.title }}
        </button>
        <div [style.background-color]="performance_bg()" id="performance"
             [title]=" api.connected ? 'De belasting van het backend. Het percentage geeft aan welk deel van de CPU-kernen actief is. Alles onder de 100% betekent dat alle verzoeken door de CPU\'s worden afgehandeld (geen wachtrij). Hoe hoger het percentage, hoe meer processen op elkaar moeten wachten m.b.t. datatoegang.' : 'Er is geen verbinding met het backend. Je wijzigingen zullen waarschijnlijk niet worden opgeslagen. Wacht tot de verbinding hersteld is, of ververs je browser.'">
            @if (api.connected) {
                {{ api.performancedata ? api.performancedata.load : '?' }} %
            } @else {
                XXX
            }
        </div>
        <div class="atrtekst">ATRPlan - <a href="https://slimmeinfrasoftware.nl" target="_blank">Slimme
            Infrasoftware</a> -
            <release-info></release-info>
        </div>
    </div>
</ng-container>


